import React from 'react';
import BaseCell from './BaseCell';
import { RestoreButton } from 'shared/buttons';

const RestoreCell = ({ onRestore, restored, themeColor = 'secondary', ...props }) => (
  <BaseCell
    {...props}
    selectable={false}
  >
    <RestoreButton onClick={onRestore} active={!restored} themeColor={themeColor} />
  </BaseCell>
);

export default RestoreCell;
